/**
 * Stock real para mostrar en buscadores y formularios.
 * Si total_stock viene en 0 pero las condiciones reflejan déficit, usa la suma por condición.
 */
export function getProductDisplayStock(stockInfo) {
  if (stockInfo == null) return 0;

  if (typeof stockInfo !== 'object') {
    return Number(stockInfo ?? 0);
  }

  const total = Number(stockInfo.total_stock ?? 0);
  const conditions = stockInfo.stock_by_condition;

  if (!conditions || typeof conditions !== 'object') {
    return total;
  }

  const sumByCondition = Object.values(conditions).reduce(
    (acc, val) => acc + Number(val ?? 0),
    0,
  );

  if (total !== 0) return total;
  if (sumByCondition !== 0) return sumByCondition;

  return total;
}

export function formatProductDisplayStock(stockInfo, options = {}) {
  const { minimumFractionDigits = 0, maximumFractionDigits = 3 } = options;
  const value = getProductDisplayStock(stockInfo);
  return value.toLocaleString('es-PE', { minimumFractionDigits, maximumFractionDigits });
}
